import { render } from "./UserDataSelection.vue?vue&type=template&id=2113d830&scoped=true"
import script from "./UserDataSelection.vue?vue&type=script&lang=js"
export * from "./UserDataSelection.vue?vue&type=script&lang=js"

import "./UserDataSelection.vue?vue&type=style&index=0&id=2113d830&lang=less&scoped=true"

import exportComponent from "/jenkins/workspace/acs-deb-pkg-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2113d830"]])

export default __exports__